import { Form, Formik, useFormikContext } from 'formik';
import React from 'react';
import { connect } from 'react-redux';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import { Label } from '../../../components';
import { searchMonthlyIssued } from '../../../actions/policy';

export const MonthlyIssuedListSearch = ({ loading }) => {
  const { setFieldValue, values } = useFormikContext();
  return (
    <Form className='mb-3'>
      <div className='row col-md-12 d-flex flex-md-row flex-sm-column'>
        <div className='form-group col-md-3'>
          <Label>Từ ngày</Label>
            <div className='div-input-date'>
              <DayPickerInput
                format='DD/MM/YYYY'
                formatDate={formatDate}
                parseDate={parseDate}
                placeholder='DD/MM/YYYY'
                onDayChange={(date) => setFieldValue('from', date)}
                value={values?.from}
                inputProps={{ className: 'form-control' }}
              />
            </div>
        </div>
        <div className='form-group col-md-3'>
          <Label>Đến ngày</Label>
          <div className='div-input-date'>
            <DayPickerInput
              format='DD/MM/YYYY'
              formatDate={formatDate}
              parseDate={parseDate}
              placeholder='DD/MM/YYYY'
              onDayChange={(date) => setFieldValue('to', date)}
              value={values?.to}
              inputProps={{ className: 'form-control' }}
            />
          </div>
        </div>
      </div>
      <button type='submit' className='btn btn-primary text-uppercase px-4' disabled={loading}>
        Tìm kiếm
      </button>
    </Form>
  );
};

const FormikWrapper = ({ values, onSubmit, loading }) => {
  return (
    <Formik initialValues={values} onSubmit={onSubmit}>
      <MonthlyIssuedListSearch loading={loading} />
    </Formik>
  );
};

const mapStateToProps = (state) => {
  return {
    values: state?.policy?.issuedCondition,
    loading: state?.policy?.loading,
  };
};

const mapDispatchToProps = { onSubmit: searchMonthlyIssued };

export default connect(mapStateToProps, mapDispatchToProps)(FormikWrapper);
